module.exports = __webpack_public_path__ + "img/xg.444244a1.png";